import styled from 'styled-components'
import BackgroundLines from '../../assets/Lines/background-lines.png'

export const LinesContainer = styled.div`
  padding: 56px 0;
  width: 100%;
  background-image: url(${BackgroundLines});

  h1 {
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 56px;

    @media (max-width: 1100px) {
      margin-bottom: 24px;
    }

    @media (max-width: 550px) {
      margin-bottom: 24px;
    }
  }

  span {
    color: #EA0B2A;
  }
`

export const LogosContainer = styled.div`
  .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slick-prev, .slick-next {
    z-index: 1;
  }

  .slick-prev:before, .slick-next:before {
    color: #EA0B2A; /* Change arrow color */
    font-size: 24px;
  }

  img {
    width: 170px !important;
    margin: auto;

    @media (max-width: 1100px) {
      width: 120px;
    }

    @media (max-width: 550px) {
      width: 100px;
    }
  }
`

export const ImageContainer = styled.div`
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: 170px;

  img {
    width: 170px !important;
    margin: auto;

    @media (max-width: 1100px) {
      width: 120px;
    }

    @media (max-width: 550px) {
      width: 100px;
    }
  }
`

export const Container = styled.div`
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 20px;
`
